export class ToggleSidebar {

  static readonly type = '[Sidebar] toggle';

}
